import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import "../../../components/LoadingSpinner/spinner.css";
import {
    Grid,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogTitle,
    
    Input,
    FormControl,
    InputLabel,
} from "@mui/material";
import { Tooltip } from "antd";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbDownAltRounded"
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";

import { makeStyles } from "@mui/styles";
import CustomButton from "../../../../src/components/CustomButton/CustomButton";
import { Card, Alert } from "reactstrap";
import NotificationPopups from "../../../NotificationPopup/NotificationPopups";
import { resetbankCashLiftingApproveReject, bankCashLiftingApproveReject } from "../../../redux/actions/bankCashLiftingApproveRejectAction";


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

function CashLiftingList() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [requestId, setrequestId] = useState("");
    const [action, setaction] = useState("");
    const [remark, setremark] = useState("");
    const [openModal, setopenModal] = useState(false);

    const classes = useStyles();
    const dispatch = useDispatch();

    const login = useSelector(({ login }) => login);
    const cashLiftinglist = useSelector(({ bankCashLiftinglist }) => bankCashLiftinglist);
    const cashLiftingApproveReject = useSelector(({ bankCashLiftingApproveReject }) => bankCashLiftingApproveReject);
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const approverejectHandler = (id, action) => {
        setrequestId(id);
        setaction(action);
        setopenModal(!openModal);
    }

    const actionHandlerFunc = () => {
        setopenModal(!openModal);
    }

    const handleChange = ({ target: { value, name } }) => {
        if (name === "remark") {
            setremark(value);
        }
    }

    const approverejectRequest = () => {

        const req = {
            actionCustomerMasterRequestVO: {
                bankId: login.data.partnerId,
                action: "Approval Pending",
                requestId,
                status: action,
                remark,
            }
        }

        if (regenerateTokenRes.success) {
            dispatch(bankCashLiftingApproveReject(req, regenerateTokenRes.data.AuthToken));
        }
    }

    useEffect(() => {
        if (cashLiftingApproveReject.success) {
            setremark("");
            setopenModal(false);
            NotificationPopups(
                "success",
                "Success",
                "Status Updated"
            );
            dispatch(resetbankCashLiftingApproveReject());
        }
        if (cashLiftingApproveReject.failed) {
            setremark("");
            setopenModal(false);
            NotificationPopups(
                "error",
                "Failed",
                "Something Went Wrong!"
            );
            dispatch(resetbankCashLiftingApproveReject());
        }
    }, [cashLiftingApproveReject])

    return (
        <>
            {cashLiftinglist.isloading ? <LoadingSpinner />
                : cashLiftinglist.success ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px",
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Report Table
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="my-3">
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow className="themeBackground">
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Request ID	{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Dealer ID
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Dealer Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Bank Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Branch Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Account Number
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Amount
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Slip Image
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Status
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Remark
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white", padding: "5px" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {cashLiftinglist.success &&
                                            []
                                                .concat(cashLiftinglist.data.errorList)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center" style={{ padding: "5px" }}>
                                                            {row.transactionId}
                                                        </TableCell>
                                                        <TableCell align="center" style={{ padding: "5px" }}>
                                                            {row.fromCustId}
                                                        </TableCell>
                                                        <TableCell align="center" style={{ padding: "5px" }}>
                                                            {row.fromName}
                                                        </TableCell>
                                                        <TableCell align="center" style={{ padding: "5px" }}>
                                                            {row.bankName}
                                                        </TableCell>
                                                        <TableCell align="center" style={{ padding: "5px" }}>
                                                            {row.branchName}
                                                        </TableCell>
                                                        <TableCell align="center" style={{ padding: "5px" }}>
                                                            {row.bankAccountNumber}
                                                        </TableCell>
                                                        <TableCell align="center" style={{ padding: "5px" }}>
                                                            {row.amount}
                                                        </TableCell>
                                                        <TableCell align="center" style={{ padding: "5px" }}>
                                                            <img
                                                                src={`data:image/jpeg;base64,${row.qrcode}`}
                                                                style={{ maxWidth: "100%" }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center" style={{ padding: "5px" }}>{row.status}</TableCell>
                                                        <TableCell align="center" style={{ padding: "5px" }}>{row.remark}</TableCell>
                                                        <TableCell align="center" style={{ padding: "5px" }}>
                                                            <>
                                                                <Tooltip title="Approve">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        disabled={row.status.toLowerCase() !== "approval pending" ? "disabled" : ""}
                                                                        onClick={() => approverejectHandler(row.transactionId, "Approved")}
                                                                    >
                                                                        {
                                                                            <ThumbUpAltRoundedIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>

                                                                <Tooltip title="Reject">
                                                                    <CustomButton
                                                                        style={{
                                                                            padding: "8px"
                                                                        }}
                                                                        disabled={row.status.toLowerCase() !== "approval pending" ? "disabled" : ""}
                                                                        onClick={() => approverejectHandler(row.transactionId, "Rejected")}
                                                                    >
                                                                        {
                                                                            <ClearRoundedIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        }
                                                                    </CustomButton>
                                                                </Tooltip>
                                                            </>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={[].concat(cashLiftinglist.data.errorList).length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px",
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 themeBackground"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                )}

            <Dialog open={openModal} onClose={actionHandlerFunc}>
                <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                <DialogActions className="p-3">
                    <div>
                        {action === "Rejected" &&
                            <FormControl required fullWidth>
                                <InputLabel htmlFor="remark">
                                    Reason For Rejection
                                </InputLabel>
                                <Input
                                    id="remark"
                                    value={remark}
                                    onChange={handleChange}
                                    name="remark"
                                    required
                                />
                            </FormControl>
                        }
                    </div>
                    <CustomButton
                        style={{
                            backgroundColor: "#fff",
                            color: "white"
                        }}
                        variant="contained"
                        onClick={actionHandlerFunc}
                    >
                        Cancel
                    </CustomButton>
                    <CustomButton
                        style={{
                            backgroundColor: "#00b9f5",
                            color: "white",

                        }}
                        variant="contained"
                        disabled={remark ? false : true}
                        // disabled={remark.length == 0 ? true : null}
                        onClick={approverejectRequest}
                    >
                        Yes
                    </CustomButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default CashLiftingList